import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const TUTOR_TOKEN_KEY = "tutor_token";

// V25 — Separate axios instance for the tutor portal. Reuses the same backend
// but persists the tutor JWT in localStorage under its own key so the admin
// session (key `at_token`) is never mixed with the tutor session.
export const tutorApi = axios.create({ baseURL: `${BACKEND_URL}/api` });

tutorApi.interceptors.request.use((config) => {
    const token = localStorage.getItem(TUTOR_TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// V29 — Global tutor-session revocation handler. When the backend returns 410
// GONE the tutor profile has been deleted (by admin or self). Clear the
// session and broadcast a CustomEvent the SPA listens to so it can render the
// full-screen "deleted" notice and redirect to /tutor/login.
tutorApi.interceptors.response.use(
    (r) => r,
    (err) => {
        try {
            if (err?.response?.status === 410) {
                const detail = err.response?.data?.detail || "";
                localStorage.removeItem(TUTOR_TOKEN_KEY);
                if (typeof window !== "undefined") {
                    window.dispatchEvent(new CustomEvent("tutor:profile-deleted", { detail: { message: detail } }));
                }
            }
        } catch { /* never block error propagation */ }
        return Promise.reject(err);
    },
);

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(", ");
    if (detail?.msg) return detail.msg;
    return String(detail);
}
